export default {
    TYPE_AREA: 'area',
    TYPE_FIELD: "field",
    TYPE_RADIO: "radio",
    TYPE_DROP_DOWN: "drop_down",
    TYPE_CHECK_BOX: "checkbox",
    TYPE_MULTIPLE: "multiple",
    TYPE_DATE: "date",
    TYPE_TIME: "time",
    TYPE_DATE_TIME: "date_time",

    PRICE_TYPE_FIXED: "fixed",
    PRICE_TYPE_PERCENT: "percent",
}



// WEBPACK FOOTER //
// ./src/view/constant/catalog/OptionConstant.js